"use client";

import React from "react";
import { Box, Map, Leaf } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Corrosion Resistance",
  description: "Engineered with marine-grade alloys and specialized coatings to withstand the harshest saltwater environments.",
  icon: Box
}, {
  title: "Precision Engineering",
  description: "Manufactured to Japanese OEM standards, ensuring exact tolerances and peak mechanical performance.",
  icon: Map
}, {
  title: "OEM Compatibility",
  description: "Seamlessly compatible with Yamaha outboards and major marine brands for reliable, drop-in replacement.",
  icon: Leaf
}];
export default function IndustrialExcellenceFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224452" id="industrial-excellence-features" className="dark bg-primary text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter mb-6 uppercase">
            Industrial Excellence
          </h2>
          <Separator className="w-24 h-1 bg-secondary rounded-md" />
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="h-full bg-card/50 border-secondary/20 shadow-md shadow-black/20 hover:scale-105 transition-transform duration-300 flex flex-col items-center text-center rounded-md">
                  <CardHeader className="pt-10 pb-4 flex flex-col items-center gap-4">
                    <div className="p-4 rounded-md bg-secondary/10 text-secondary mb-2">
                      <Icon size={48} strokeWidth={1} />
                    </div>
                    <CardTitle className="font-default text-xl md:text-2xl font-semibold tracking-tight">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pb-10 px-8">
                    <p className="font-mono text-sm text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}